export class StaffConstants {
  public static STAFF: string = 'staff'
  public static REPORTS: string = 'reports'
  public static ANNOUNCEMENTS: string = 'announcements'
  public static USER_ACCOUNTS: string = 'user-accounts'
  public static TUTORIAL_VIDEOS: string = 'tutorial-videos'
  public static AWS: string = 'aws'
}
